import { ref } from 'vue';
import { SearchProductItem } from '../domain/search-product.model.js';

export function useSelectedProduct() {
  const selectedProduct = ref<number | null>(null);

  function selectProduct(product: SearchProductItem) {
    const firstAvailableVariantId = product.variants.at(0)?.id;
    if (firstAvailableVariantId) {
      selectedProduct.value = firstAvailableVariantId;
    } else {
      selectedProduct.value = null;
    }
  }

  function clearProductSelection() {
    selectedProduct.value = null;
  }

  return { selectedProduct, selectProduct, clearProductSelection };
}

export function useSelectedProducts() {
  const selectedProducts = ref<number[]>([]);

  function selectProduct(product: SearchProductItem) {
    const firstAvailableVariantId = product.variants.at(0)?.id;
    if (firstAvailableVariantId) {
      const uniqueIds = new Set(selectedProducts.value);
      uniqueIds.add(firstAvailableVariantId);
      selectedProducts.value = Array.from(uniqueIds);
    }
  }
  function deselectProduct(product: SearchProductItem) {
    const firstAvailableVariantId = product.variants.at(0)?.id;
    if (firstAvailableVariantId) {
      const uniqueIds = new Set(selectedProducts.value);
      uniqueIds.delete(firstAvailableVariantId);
      selectedProducts.value = Array.from(uniqueIds);
    }
  }

  function toggleProduct(product: SearchProductItem) {
    if (isProductSelected(product)) {
      deselectProduct(product);
    } else {
      selectProduct(product);
    }
  }

  function isProductSelected(product: SearchProductItem): boolean {
    const uniqueIds = new Set(selectedProducts.value);
    const variantId = product.variants.at(0)?.id;
    if (variantId) {
      return uniqueIds.has(variantId);
    }

    return false;
  }

  return { selectedProducts, toggleProduct, isProductSelected };
}
